import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft, ChevronDown, ChevronUp, Phone } from "lucide-react";
import { GOOGLE_REVIEWS_URL } from "../data/avisGoogle";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_azure-seo-boost/artifacts/v4b4r58r_logo%20AT.png";

const faqData = [
  {
    category: "Services et Tarifs",
    questions: [
      {
        q: "Quels sont vos tarifs pour une désinsectisation à Nice ?",
        a: "Nos tarifs dépendent de plusieurs facteurs : la surface à traiter, le type de nuisible, et le degré d'infestation. Pour un appartement standard (50-80m²), comptez entre 120€ et 250€. Nous vous proposons toujours un devis gratuit et personnalisé après évaluation de votre situation. Appelez-nous au 07 64 07 95 35 pour obtenir votre devis rapidement."
      },
      {
        q: "Intervenez-vous 24h/24 vraiment ?",
        a: "Oui, absolument ! Nous comprenons que certaines situations nécessitent une intervention d'urgence (nid de guêpes près d'une école, rats dans un restaurant, etc.). Nous sommes joignables et disponibles 24 heures sur 24, 7 jours sur 7, week-ends et jours fériés inclus, dans tout le département des Alpes-Maritimes (06) et l'Est du Var (83)."
      },
      {
        q: "Proposez-vous des devis gratuits ?",
        a: "Oui, tous nos devis sont gratuits et sans engagement. Nous pouvons vous donner une première estimation par téléphone, puis affiner le devis après une visite si nécessaire. Contactez-nous au 07 64 07 95 35 ou par email à azur.tech3d@yahoo.com."
      },
      {
        q: "Acceptez-vous les paiements en plusieurs fois ?",
        a: "Pour les interventions importantes ou les contrats annuels, nous pouvons proposer des facilités de paiement. Discutons-en ensemble lors de l'établissement du devis."
      }
    ]
  },
  {
    category: "Punaises de Lit",
    questions: [
      {
        q: "Comment savoir si j'ai des punaises de lit ?",
        a: "Les signes révélateurs sont : des piqûres en ligne sur la peau (souvent au réveil), de petites taches noires sur les draps (déjections), des traces de sang, une odeur douceâtre, et la présence d'insectes bruns ovales (4-7mm) dans les coutures du matelas. Si vous constatez un ou plusieurs de ces signes, contactez-nous rapidement pour une inspection."
      },
      {
        q: "Combien de temps faut-il pour éliminer les punaises de lit ?",
        a: "Le traitement initial prend généralement 2 à 4 heures selon la taille du logement. Nous effectuons une visite de contrôle 15 jours plus tard pour garantir l'éradication complète. Dans 95% des cas, une intervention suffit, mais parfois une seconde intervention est nécessaire pour les infestations importantes."
      },
      {
        q: "Dois-je jeter mon matelas si j'ai des punaises de lit ?",
        a: "Non, pas nécessairement ! Notre traitement professionnel (thermique + chimique) élimine les punaises dans le matelas. Jeter le matelas peut même propager l'infestation ailleurs. Après notre traitement, nous vous recommandons d'utiliser une housse anti-punaises pour protéger durablement votre literie."
      },
      {
        q: "Les punaises de lit transmettent-elles des maladies ?",
        a: "Bonne nouvelle : les punaises de lit ne transmettent pas de maladies. Cependant, leurs piqûres peuvent causer des démangeaisons importantes, des réactions allergiques, et un stress psychologique significatif. C'est pourquoi il faut agir rapidement dès leur détection."
      }
    ]
  },
  {
    category: "Dératisation",
    questions: [
      {
        q: "J'ai vu un rat, dois-je appeler immédiatement ?",
        a: "Oui, absolument ! Si vous voyez un rat, cela signifie souvent qu'il y en a d'autres cachés. Les rats se reproduisent très rapidement (une femelle peut avoir 50 petits par an). Plus vous attendez, plus l'infestation s'aggrave et plus le traitement sera complexe et coûteux. Appelez-nous au 07 64 07 95 35 pour une intervention rapide."
      },
      {
        q: "Les produits qu'on trouve en grande surface sont-ils efficaces ?",
        a: "Les produits grand public ont une efficacité limitée. Les rats peuvent développer une méfiance envers ces produits (néophobie). Nos produits professionnels sont plus puissants, et surtout, nous savons où les placer stratégiquement. De plus, une mauvaise utilisation des raticides peut être dangereuse pour les enfants et animaux domestiques."
      },
      {
        q: "Combien de temps faut-il pour éliminer les rats ?",
        a: "Généralement, 2 à 3 semaines avec plusieurs passages de contrôle. Lors de la première intervention, nous posons les appâts et bloquons les accès. Les passages suivants permettent de vérifier l'efficacité et réajuster si nécessaire. Chaque situation est unique, c'est pourquoi nous adaptons notre protocole."
      },
      {
        q: "Comment éviter que les rats reviennent ?",
        a: "La prévention est essentielle ! Nous colmatons les points d'entrée, vous conseillons sur le stockage des aliments, et pouvons mettre en place un suivi préventif régulier. Pour les professionnels (restaurants, entrepôts), nous proposons des contrats annuels avec visites préventives."
      }
    ]
  },
  {
    category: "Guêpes et Frelons",
    questions: [
      {
        q: "Puis-je détruire moi-même un nid de guêpes ?",
        a: "NON, c'est très dangereux ! Chaque année, des accidents graves (voire mortels) surviennent lors de tentatives d'élimination par des particuliers. Les guêpes attaquent en masse si elles se sentent menacées. Nous avons l'équipement professionnel (combinaison, perche télescopique) et les produits adaptés. N'intervenez jamais seul, appelez-nous : 07 64 07 95 35."
      },
      {
        q: "Quelle est la différence entre guêpes et frelons ?",
        a: "Les frelons européens sont plus gros (3cm) que les guêpes (1,5cm), avec un corps brun-jaune. Les frelons asiatiques (espèce invasive) ont un corps noir avec une bande orange. Les nids de frelons sont aussi plus grands. Tous nécessitent une intervention professionnelle, mais les frelons asiatiques sont particulièrement agressifs."
      },
      {
        q: "À quelle période faut-il détruire les nids ?",
        a: "Idéalement au printemps (avril-mai) quand les nids sont petits. Mais nous intervenons toute l'année, même en été quand les nids sont gros et les colonies nombreuses. En automne, les nids se vident naturellement, mais il faut les retirer pour éviter une réutilisation au printemps suivant."
      },
      {
        q: "Combien coûte la destruction d'un nid de guêpes ?",
        a: "Le tarif dépend de la hauteur et de l'accessibilité du nid. Pour un nid accessible (sous toiture, abri de jardin) : 80-120€. Pour un nid en hauteur nécessitant une perche ou nacelle : 150-250€. Frelons asiatiques : tarif spécifique selon la complexité. Devis gratuit par téléphone."
      }
    ]
  },
  {
    category: "Désinfection",
    questions: [
      {
        q: "Quelle est la différence entre nettoyage et désinfection ?",
        a: "Le nettoyage élimine la saleté visible, mais pas forcément les micro-organismes. La désinfection tue les virus, bactéries et champignons grâce à des produits virucides certifiés. Pour un environnement vraiment sain (notamment après COVID ou dans les lieux publics), la désinfection professionnelle est indispensable."
      },
      {
        q: "Les produits que vous utilisez sont-ils sans danger ?",
        a: "Oui, nous utilisons uniquement des produits homologués, conformes aux normes européennes (EN 14476), efficaces contre les virus dont le COVID-19, mais sans danger pour l'homme et l'environnement une fois secs. Nous respectons scrupuleusement les temps de contact et d'aération. Vous recevez la fiche technique de tous les produits utilisés."
      },
      {
        q: "Combien de temps doit-on attendre avant de réintégrer les locaux ?",
        a: "Généralement 1 à 2 heures après la fin de notre intervention, le temps que les produits sèchent et que l'aération soit complète. Nous vous indiquons précisément l'heure de réintégration possible. Pour les lieux recevant du public, nous pouvons intervenir la nuit pour une réouverture le matin."
      },
      {
        q: "Fournissez-vous un certificat après désinfection ?",
        a: "Oui, systématiquement ! Nous vous remettons une attestation d'intervention mentionnant la date, les surfaces traitées, les produits utilisés, et la conformité aux normes. Ce document est important pour vos assurances, contrôles sanitaires, ou audits qualité."
      }
    ]
  },
  {
    category: "Zone d'Intervention",
    questions: [
      {
        q: "Dans quelles régions intervenez-vous ?",
        a: "Nous intervenons dans deux grandes régions : PACA (Provence-Alpes-Côte d'Azur) avec les Alpes-Maritimes (06) et le Var Est (83), ainsi qu'en Île-de-France avec Paris (75) et tous les départements de la région parisienne (92, 93, 94, 77, 78, 91, 95). Aucun déplacement n'est trop loin pour nous !"
      },
      {
        q: "Intervenez-vous vraiment dans toute l'Île-de-France ?",
        a: "Oui, nous couvrons Paris et toute l'Île-de-France : Paris (tous arrondissements), Hauts-de-Seine (92), Seine-Saint-Denis (93), Val-de-Marne (94), Seine-et-Marne (77), Yvelines (78), Essonne (91), et Val-d'Oise (95). Versailles, Créteil, Nanterre, Boulogne, Levallois, Neuilly et toutes les communes environnantes."
      },
      {
        q: "Intervenez-vous toujours dans le Sud (06 et 83) ?",
        a: "Absolument ! Nous maintenons nos interventions dans toute la région PACA : Nice, Cannes, Antibes, Grasse, Menton dans les Alpes-Maritimes (06), ainsi que Fréjus, Saint-Raphaël, Saint-Tropez dans le Var Est (83). Notre extension vers Paris ne change rien à notre présence dans le Sud !"
      },
      {
        q: "Y a-t-il des frais de déplacement ?",
        a: "Les frais de déplacement sont inclus dans nos tarifs pour les zones urbaines principales (Nice, Cannes, Paris intramuros). Pour les communes plus éloignées ou l'arrière-pays, des frais minimes peuvent s'appliquer (généralement 20-40€). Nous vous l'indiquons clairement lors du devis."
      }
    ]
  },
  {
    category: "Pour les Professionnels",
    questions: [
      {
        q: "Proposez-vous des contrats annuels pour les professionnels ?",
        a: "Oui, nous proposons des contrats de maintenance annuels incluant des visites préventives régulières (mensuelles, trimestrielles, ou semestrielles selon vos besoins). C'est la solution idéale pour les restaurants, hôtels, commerces alimentaires, entrepôts. Tarifs dégressifs et interventions d'urgence prioritaires pour nos clients sous contrat."
      },
      {
        q: "Établissez-vous un plan de lutte antiparasitaire ?",
        a: "Oui, c'est même obligatoire pour certains secteurs (restauration, agroalimentaire, santé). Nous établissons un plan de lutte personnalisé, installons des appâts sécurisés, posons des pièges, et assurons un suivi avec registre d'intervention. Vous êtes ainsi en conformité avec les exigences sanitaires et les contrôles HACCP."
      },
      {
        q: "Intervenez-vous en dehors des heures d'ouverture ?",
        a: "Absolument ! Nous comprenons que votre activité ne peut être perturbée. Nous intervenons volontiers en soirée, la nuit, le week-end, ou aux horaires qui vous arrangent. Pour la désinfection de commerces, nous pouvons intervenir après la fermeture pour une réouverture le lendemain matin."
      },
      {
        q: "Êtes-vous discrets dans vos interventions ?",
        a: "Oui, la discrétion est notre priorité, surtout pour les établissements recevant du public. Nous utilisons des véhicules banalisés (pas de logo visible), nos techniciens ne portent pas de tenue voyante, et nous nous adaptons à vos contraintes pour préserver votre image de marque."
      }
    ]
  }
];

function FAQ() {
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenQuestion(openQuestion === key ? null : key);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>FAQ Dératisation & Désinsectisation Nice (06) : Prix, Délais | Azur Tech</title>
        <meta name="description" content="Toutes les réponses sur nos interventions anti-nuisibles à Nice et dans les Alpes-Maritimes (06) : tarifs, délais, garanties, produits utilisés ☎ 07 64 07 95 35" />
        <link rel="canonical" href="https://azurtech06.fr/faq" />
      </Helmet>
      {/* Header */}
      <header className="bg-white shadow-md fixed w-full top-0 z-50">
        <div className="bg-[#0f172a] text-white py-1.5 text-xs md:text-sm" data-testid="trust-banner">
          <div className="container mx-auto px-4 flex items-center space-x-2 md:space-x-3 overflow-hidden">
            <span className="truncate">Entreprise certifiée • SIREN vérifié 821 012 630</span>
            <span className="text-gray-500">•</span>
            <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-testid="trust-banner-google-link" className="flex items-center text-yellow-400 hover:text-yellow-300 font-semibold flex-shrink-0">⭐ 5/5 Avis Google</a>
          </div>
        </div>
        <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-3">
            <img src={LOGO_URL} alt="Azur Tech Logo" className="h-12 w-auto" />
            <div>
              <h2 className="text-xl font-bold text-cyan-600">Azur Tech</h2>
              <p className="text-xs text-gray-600">Expert 3D</p>
            </div>
          </Link>
          <a 
            href="tel:0764079535" 
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-bold flex items-center space-x-2 transition-all shadow-lg hover:shadow-xl"
          >
            <Phone className="w-5 h-5" />
            <span className="hidden md:inline">07 64 07 95 35</span>
          </a>
        </nav>
      </header>

      {/* Content */}
      <div className="pt-32 md:pt-36 pb-16">
        <div className="container mx-auto px-4">
          {/* Breadcrumb */}
          <Link to="/" className="inline-flex items-center text-cyan-600 hover:text-cyan-700 mb-8">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour à l'accueil
          </Link>

          {/* Page Title */}
          <div className="mb-12 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Questions Fréquentes (FAQ)
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Toutes les réponses à vos questions sur nos services de désinsectisation, dératisation et désinfection
            </p>
          </div>

          {/* FAQ Content */}
          <div className="max-w-4xl mx-auto">
            {faqData.map((category, categoryIndex) => (
              <div key={categoryIndex} className="mb-8">
                <h2 className="text-2xl font-bold text-cyan-600 mb-4 flex items-center">
                  <span className="bg-cyan-100 rounded-full w-10 h-10 flex items-center justify-center mr-3 text-cyan-600">
                    {categoryIndex + 1}
                  </span>
                  {category.category}
                </h2>
                <div className="space-y-3">
                  {category.questions.map((item, questionIndex) => {
                    const isOpen = openQuestion === `${categoryIndex}-${questionIndex}`;
                    return (
                      <div
                        key={questionIndex}
                        className="bg-white rounded-lg shadow-md overflow-hidden"
                        data-testid={`faq-item-${categoryIndex}-${questionIndex}`}
                      >
                        <button
                          onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                          className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors text-left"
                        >
                          <span className="font-semibold text-gray-900 pr-4">{item.q}</span>
                          {isOpen ? (
                            <ChevronUp className="w-5 h-5 text-cyan-600 flex-shrink-0" />
                          ) : (
                            <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                          )}
                        </button>
                        {isOpen && (
                          <div className="px-6 pb-4 text-gray-700 leading-relaxed border-t border-gray-100 pt-4">
                            {item.a}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Still have questions CTA */}
          <div className="mt-16 bg-gradient-to-br from-cyan-600 to-blue-600 rounded-xl p-8 text-center text-white max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold mb-4">
              Vous ne trouvez pas votre réponse ?
            </h3>
            <p className="text-xl mb-6">
              Nos experts sont à votre écoute 24h/24 - 7j/7
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:0764079535"
                className="bg-white text-cyan-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all inline-flex items-center justify-center"
              >
                <Phone className="w-5 h-5 mr-2" />
                07 64 07 95 35
              </a>
              <a
                href="mailto:azur.tech3d@yahoo.com"
                className="bg-cyan-700 text-white px-8 py-4 rounded-lg font-bold hover:bg-cyan-800 transition-all inline-flex items-center justify-center"
              >
                ✉️ azur.tech3d@yahoo.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
